"use client";
'use strict';

var React = require('react');
var array = require('../utils/array.js');
var useStateCallback = require('./useStateCallback.js');

/**
 * React hook to manage multiply value states
 *
 * @param initialState the initial value state
 * @example
 * ```javascript
 * const [innerValue, setInnerValue] = useMultiValue<string | number>(defaultIndex || [])
 * ```
 */
function useMultiValue(initialState = []) {
    const [value, setValue] = useStateCallback.useStateCallback(initialState);
    const update = React.useCallback((val, callback) => {
        const pos = array.findIndex(value, val);
        setValue(pos >= 0 ? array.removeIndex(value, pos) : array.addItem(value, val), callback);
    }, [setValue, value]);
    return [value, update];
}

exports.useMultiValue = useMultiValue;
//# sourceMappingURL=useMultiValue.js.map
